/* share social */
$(function() {
    var toggle = $('.socialShareToggle');

    toggle.click(function() {
        event.preventDefault();
        $(this).toggleClass('__active');
        $(this)
            .siblings('.socialShareContent')
            .toggleClass('__active');
    });
});
